import Doctor from '@doctor/medigo-sdk/lib/doctor';
import { CurrentEnv } from '@proccess/constants';

const sdkDoctor = new Doctor({
  apiRoot: CurrentEnv.API_BE,
} as any);

export default sdkDoctor;
